import { toast } from 'react-toastify';
import { CustomCopyTypeTags } from '~/partials/Tags';
import { cn } from '~/util';
import { LevelCustomCopy } from '~/util/types/levels';

export const LevelCustomCopyPost = ({
    custom_copy_data,
    copy_id,
    allowClick = true,
    showStatusWhenAllowed = false,
}: {
    custom_copy_data?: LevelCustomCopy;
    copy_id: number;
    allowClick?: boolean;
    showStatusWhenAllowed?: boolean;
}) => (
    <button
        className={cn(
            'max-w-xs w-full rounded-xl border p-2 transition-colors bg-background-light',
            allowClick && 'hover:bg-background-darker cursor-pointer',
        )}
        onClick={() => {
            if (allowClick) {
                navigator.clipboard.writeText(copy_id.toString());
                toast.info(`Copied ID ${copy_id} to clipboard!`);
            }
        }}
    >
        <div className="flex justify-between items-center mb-2 gap-2">
            <div className="flex items-center gap-2">
                <CustomCopyTypeTags
                    item={custom_copy_data?.id_type ?? 'Unknown'}
                />
                <h4 className="font-semibold">ID: {copy_id}</h4>
            </div>
            {(showStatusWhenAllowed ||
                custom_copy_data?.status == 'Banned') && (
                <span
                    className={cn(
                        'text-sm font-medium uppercase',
                        custom_copy_data?.status === 'Banned'
                            ? 'text-destructive'
                            : !custom_copy_data
                              ? 'text-claimed'
                              : 'text-confirm',
                    )}
                >
                    {custom_copy_data?.status === 'Banned'
                        ? 'Banned'
                        : custom_copy_data?.status === 'Allowed'
                          ? 'Allowed'
                          : 'Unknown'}
                </span>
            )}
        </div>
        <p className=" text-left">
            Notes:{' '}
            {custom_copy_data
                ? custom_copy_data.description || 'No description provided.'
                : 'This custom copy ID has not been reviewed yet.'}
        </p>
    </button>
);
